import { RecordString } from '../models/common.models';

export const getQueryParams = (): RecordString => {
  const search = window.location.href.split('?');
  if (search.length < 2) {
    return {};
  }
  const searchParams = new URLSearchParams(search[1]);
  const queryParams: RecordString = {};
  searchParams.forEach((value, key) => {
    queryParams[key] = value;
  });
  return queryParams;
};

export const getQueryParam = (value: string): string => {
  const params = getQueryParams();
  return params[value];
};
